import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { authAPI } from '../lib/api';

export default function ResetPassword() {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token') || '';

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        
        // Client-side validation
        if (password.length < 8) {
            setError('Password must be at least 8 characters.');
            return;
        }
        
        if (password !== confirmPassword) {
            setError('Passwords do not match.');
            return;
        }

        setLoading(true);

        try {
            await authAPI.resetPassword(token, password);
            setSuccess(true);
        } catch (err) {
            if (err.response?.data?.error) {
                setError(err.response.data.error);
            } else {
                setError('Could not reset your password. The link may have expired - please request a new one.');
            }
        } finally {
            setLoading(false);
        }
    };

    if (!token) {
        return (
            <div style={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
            }}>
                <div style={{
                    background: 'white',
                    padding: '40px',
                    borderRadius: '12px',
                    boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
                    width: '100%',
                    maxWidth: '400px'
                }}>
                    <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                        <h1 style={{ color: '#333', fontSize: '28px', marginBottom: '10px' }}>
                            Reset Password
                        </h1>
                    </div>

                    <div className="alert alert-error" style={{ marginBottom: '20px' }}>
                        This reset link is invalid. Please request a new one.
                    </div>

                    <div style={{ textAlign: 'center' }}>
                        <Link to="/forgot-password" style={{ color: '#667eea', textDecoration: 'none' }}>
                            Request a new reset link
                        </Link>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
        }}>
            <div style={{
                background: 'white',
                padding: '40px',
                borderRadius: '12px',
                boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
                width: '100%',
                maxWidth: '400px'
            }}>
                <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                    <h1 style={{ color: '#333', fontSize: '28px', marginBottom: '10px' }}>
                        Reset Password
                    </h1>
                    <p style={{ color: '#666' }}>
                        Enter your new password
                    </p>
                </div>

                {success ? (
                    <div className="alert alert-success" style={{ marginBottom: '20px' }}>
                        Your password has been changed. You can now sign in.
                    </div>
                ) : (
                    <>
                        {error && (
                            <div className="alert alert-error" style={{ marginBottom: '20px' }}>
                                {error}{' '}
                                {!error.startsWith('Password') && (
                                    <Link to="/forgot-password" style={{ color: '#667eea' }}>Request a new link</Link>
                                )}
                            </div>
                        )}

                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label className="form-label">New Password</label>
                                <input
                                    type="password"
                                    className="form-input"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                    placeholder="Enter new password"
                                    autoComplete="new-password"
                                    disabled={loading}
                                />
                            </div>

                            <div className="form-group">
                                <label className="form-label">Confirm New Password</label>
                                <input
                                    type="password"
                                    className="form-input"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    required
                                    placeholder="Confirm new password"
                                    autoComplete="new-password"
                                    disabled={loading}
                                />
                            </div>

                            <button
                                type="submit"
                                className="btn btn-primary"
                                style={{ width: '100%', padding: '12px', fontSize: '16px' }}
                                disabled={loading}
                            >
                                {loading ? 'Saving...' : 'Set new password'}
                            </button>
                        </form>
                    </>
                )}

                <div style={{ marginTop: '20px', textAlign: 'center' }}>
                    <Link to="/login" style={{ color: '#667eea', textDecoration: 'none' }}>
                        ← Back to sign in
                    </Link>
                </div>
            </div>
        </div>
    );
}